export const FOLDER = {
  IOW_INFRA_TYPE_ID: 4,
};
